import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartidaPresService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getPartidaPres(): Observable<any> {
    return this.http.get(this.baseUrl + 'parPartidaPresupuestarias', { headers: this.header(this.token) });
  }

  getPartidaPresTipoTraspaso(idTraspasoO:number, idTipoTraspaso: number, idTecho): Observable<any> {    
    return this.http.get(this.baseUrl + 'parPartidaPresupuestariasTipoTraspaso/'  + idTraspasoO +'/'  + idTipoTraspaso +'/'  + idTecho, { headers: this.header(this.token) });
  }

  getPartidaPresById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parPartidaPresupuestaria/' + id, { headers: this.header(this.token) });
  }

  postPartidaPres(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parPartidaPresupuestaria', bodyString, { headers: this.header(this.token) });
  }

  putPartidaPres(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parPartidaPresupuestaria', bodyString, { headers: this.header(this.token) });
  }

  deletePartidaPres(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parPartidaPresupuestaria/' + id, { headers: this.header(this.token) });
  }
}
